import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button } from "@platform/design-system";

interface Props {
  handleBack: VoidFunction;
  name: string;
  isDisabled?: boolean;
}

const BackButton = ({
  handleBack,
  name,
  isDisabled = false,
}: Props): React.JSX.Element => (
  <Button
    startIcon={<ArrowBackIcon />}
    variant="secondary"
    onClick={handleBack}
    disabled={isDisabled}
  >
    BACK: {name}
  </Button>
);

export default BackButton;
